import React, { Component } from 'react'
import { Container, Header, Dimmer, Loader, Image, Segment } from 'semantic-ui-react';
import MaterialTable from 'material-table'
import Parse from 'widget/parse'
import localization from 'widget/MaterialTableOpt'
import { dateCol, exportPdf } from 'views/web/CustomMaterialTable';

const columns = () => ([
  { title: '帳戶名稱', field: 'value' },
  { title: '分行代號', field: 'branch' },
  { title: '帳號', field: 'accountNum' },
]);
export default class Fin1103 extends Component {
  state = {
    dataArr: [],
    deleteConfirm: false,
    loading: true
  }

  componentDidMount() {
    this.handleFetch();
  }

  componentWillReceiveProps(nextProps) {
    this.handleFetch(nextProps);
  }

  handleFetch = async (props = this.props) => {
    const { match, companyObj } = props;
    const companyId = companyObj.objectId;
    const bankacc = await Parse.queryData('bankacc', { companyId });
    this.setState({ dataArr: bankacc, loading: false });
  }

  handleAdd = async () => {
    const { newData } = this.state
    const obj = {
      ...newData,
    };
    await Parse.saveData('bankacc', obj);
  }

  handleUpdate = async () => {
    const { newData } = this.state
    const obj = { ...newData };
    await Parse.saveData('bankacc', obj);
  }

  handleDelete = async () => {
    const { oldData } = this.state
    await Parse.deleteData('bankacc', oldData);
    this.setState({ oldData: {} })
  }

  render() {
    const { companyObj, auth } = this.props
    const { dataArr, loading } = this.state;

    const editable = {
      isEditHidden: () => !auth.edit,
      isDeleteHidden: () => !auth.edit,
      onRowAdd: newData =>
        new Promise(async (resolve, reject) => {
          const db = Parse.Object.extend("bankacc");
          const newDoc = new db();
          const doc = await newDoc.save();
          const data = [...dataArr];
          const obj = {
            _id: doc.id,
            id: doc.id,
            objectId: doc.id,
            companyId: companyObj.objectId || '',
            companyName: companyObj.name || '',
            ...newData
          }
          data.push(obj);
          this.setState({ dataArr: data, newData: obj }, () => resolve());
        }).then(() => this.handleAdd()),
      onRowUpdate: (newData, oldData) =>
        new Promise((resolve, reject) => {
          const data = [...dataArr];
          const index = data.indexOf(oldData);
          data[index] = newData;
          this.setState({ dataArr: data, newData, oldData }, () => resolve());
        }).then(() => this.handleUpdate()),
      onRowDelete: oldData =>
        new Promise((resolve, reject) => {
          let data = [...dataArr];
          const index = data.indexOf(oldData);
          data.splice(index, 1);
          this.setState({ dataArr: data, oldData }, () => resolve());
        }).then(() => this.handleDelete()),
    }

    if (auth.edit === false) {
      delete editable.onRowAdd
    }

    return (<>
      <Header inverted={companyObj.inverted} as='h2' style={{ margin: '2rem 0' }}>銀行帳戶</Header>
      <MaterialTable
        isLoading={loading}
        localization={localization()}
        style={{ width: '600px' }}
        columns={columns()}
        options={{
          addRowPosition: "first",
          exportButton: true,
          exportAllData: true,
          exportPdf: (columns, data) => exportPdf(columns, data),
          pageSize: dataArr.length || 10,
          search: false
        }}
        data={dataArr}
        title=''
        editable={editable}
      />
      <br />
      <br />
    </>)
  }
}